export const removeSpace = (value: string) => {
    return value.replace(/\s/g, '');
};